import React, { CSSProperties, ReactNode, useState } from 'react'
import styles from './styles/user-message-screen.module.scss'
import { useTranslation } from 'react-i18next'
import { ReactComponent as HomeIcon } from 'images/icons/icn_home.svg'
import InfoPanel from './InfoPanel'

interface MoreInfoProps {
  text: ReactNode
  toggleText: string
}

const MoreInfo = ({ text, toggleText }: MoreInfoProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggleMoreInfo = () => setIsOpen(prev => !prev)

  return (
    <>
      (
      <button onClick={toggleMoreInfo} className={styles.moreInfoToggle}>
        {toggleText}
      </button>
      ){isOpen && <InfoPanel info={text} as={'p'} className={styles.moreInfoPanel} />}
    </>
  )
}

export interface Props {
  icon?: ReactNode
  iconStyle?: CSSProperties
  header?: string
  infoText?: string | ReactNode
  backLink?: string | ReactNode
  backLinkText?: string
  backLinkIcon?: ReactNode
  openLinkInNewTab?: boolean
  moreInfo?: MoreInfoProps
}

const UserMessageScreen = ({
  icon,
  iconStyle = {},
  header,
  infoText,
  moreInfo,
  backLink = '/',
  backLinkText,
  backLinkIcon = <HomeIcon />,
  openLinkInNewTab = false,
}: Props) => {
  const { t } = useTranslation('strMessageScreen')
  const [isOpen, setIsOpen] = useState(false)
  const toggleMoreInfo = () => setIsOpen(prev => !prev)
  const newTabProps = openLinkInNewTab
    ? {
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {}

  const effectiveBackLinkText = backLinkText || t('backToHome')

  return (
    <div className={styles.container}>
      <div className={styles.mainIcon} style={iconStyle}>
        {icon}
      </div>

      <h1 className={styles.header}>{header}</h1>

      {(infoText || moreInfo) && (
        <p className={styles.infoText}>
          {infoText}{' '}
          {moreInfo && (
            <>
              (
              <button onClick={toggleMoreInfo} className={styles.moreInfoToggle}>
                {moreInfo.toggleText}
              </button>
              )
            </>
          )}
        </p>
      )}
      {isOpen && moreInfo && <InfoPanel info={moreInfo.text} className={styles.moreInfoPanel} />}

      {typeof backLink !== 'string' ? (
        backLink
      ) : (
        <a className={styles.link} href={backLink} {...newTabProps}>
          {backLinkIcon && <span className={styles.linkIcon}>{backLinkIcon}</span>}
          {effectiveBackLinkText}
        </a>
      )}
    </div>
  )
}

export default UserMessageScreen
